<template>
	<modal v-on="$listeners" :title="title" class="ui-contact-modal">
		<div class="ui-contact-modal__subtitle">{{ subtitle }}</div>
		<form @submit.prevent="onSubmit">
			<div class="ui-contact-modal__fields">
				<label>
					Prénom
					<input type="text" name="firstname" placeholder="Prénom" v-model="model.first_name">
					<span v-if="errorcheck && $v.model.first_name.$invalid" class="texterror">Champ obligatoire. Merci de le compléter.</span>
				</label>
				<label>
					Nom
					<input type="text" name="name" placeholder="Nom" v-model="model.name">
					<span v-if="errorcheck && $v.model.name.$invalid" class="texterror">Champ obligatoire. Merci de le compléter.</span>
				</label>
				<label>
					Adresse e-mail
					<input type="email" name="email" placeholder="Adresse e-mail" v-model="model.email">
					<span v-if="errorcheck && $v.model.email.$invalid" class="texterror">Champ obligatoire. Merci de le compléter.</span>
				</label>
				<label>
					Téléphone
					<vue-phone-number-input
						color="transparent"
						valid-color="transparent"
						default-country-code="FR"
						:preferred-countries="['FR']"
						:translations="{ phoneNumberLabel: 'Téléphone' }"
						v-model="tmpPhone"
						@input="$v.model.phone_number.$touch"
						@update="d => model.phone_number = d"
					/>
					<span v-if="errorcheck && $v.model.phone_number.$invalid" class="texterror">Champ obligatoire. Merci de le compléter.</span>
				</label>
			</div>

			<ui-button
				type="submit"
				:loading="saving"
				w="200px"
				h="40px">
				{{ button }}
			</ui-button>
		</form>

    <div style="margin-top: 30px">
      <span>Ou&nbsp;</span>
      <router-link to="/signin" title="Se connecter à votre compte COOLOC">
        Cliquez ici pour vous connecter si vous avez déjà un compte
      </router-link>
    </div>

		<!-- Remove default button -->
		<span slot="buttons"></span>
	</modal>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    button: {
      type: String,
      required: true,
    },
    extraInfo: {
      type: Object,
      required: false,
    },
  },
  data: () => ({
    model: {
      first_name: '',
      name: '',
      email: '',
      phone_number: '',
    },
    tmpPhone: '',
    saving: false,
    errorcheck: false,
  }),
  validations: {
    model: {
      first_name: {
        required,
      },
      name: {
        required,
      },
      email: {
        required,
        email,
      },
      phone_number: {
        required,
        isTelephone(value) {
          return !!(value && value.isValid)
        },
      },
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch()
      this.errorcheck = false
      if (this.$v.$invalid) {
        this.errorcheck = true
        return
      }

      if (this.saving) return
      this.saving = true

      const data = {
        ...this.model,
        phone_number: this.model.phone_number.formatInternational,
        ...this.extraInfo,
      }
      if (window.localStorage) {
        localStorage.setItem('last_contact_request', JSON.stringify(data))
      }

      this.$http.post('/api/contact-request', data).then(
        () => this.$emit('confirm'),
        err => this.$error(err),
      ).finally(() => this.saving = false)
    },
  },
  components: {
    Modal: require('@/ui/Modal').default,
    VuePhoneNumberInput: require('@/ui/VuePhoneNumberInput').default,
    uiButton: require('@/ui/Button').default,
  },
}
</script>

<style lang="scss">
@import "../../static/scss/variables";
.ui-contact-modal {
	#popup-info {
		max-width: 615px;
	}
	&__subtitle {
		line-height: 19px;
		white-space: pre-line;
		margin-bottom: 12px;
	}
	&__fields {
		display: flex;
		flex-wrap: wrap;
		margin: 0 -25px 25px;

		label {
			width: 50%;
			@media #{$phone} {
				width: 100%;
			}

			padding: 15px 25px;
			text-align: left;
			font-weight: normal;
			font-size: 16px;
			line-height: 19px;

			input {
				margin-top: 4px;
				text-align: left;
				line-height: 35px;
				height: 35px;
				font-size: 16px;
				padding: 0 12px;
				background: transparent !important;
			}
		}

		label[for=VuePhoneNumberInput_country_selector], label[for=VuePhoneNumberInput_phone_number] {
			display: none;
		}
		#VuePhoneNumberInput_phone_number {
			padding-right: 0;
		}
		.vue-phone-number-input {
			margin-top: 4px;

			.field-input {
				margin-top: 0 !important;
				line-height: 35px !important;
				min-height: 35px !important;
				height: 35px !important;
				font-size: 16px !important;
				transition: none !important;
			}
			.select-country-container {
				width: 90px;
				flex-basis: 90px;
				min-width: 90px;
				.input-country-selector {
					margin-left: -5px;
				}
			}
			.country-selector-arrow {
				transform: scale(0.5) translate(-50%, -75%) !important;
			}
		}
	}
	.simple-popup#popup-info .mfp-close.white-button {
		z-index: 0;
	}
	.texterror {
		margin-top: 10px;
		display: block;
	}
}
</style>
